import React from "react";
import { Row, Col } from "react-bootstrap";
import "../services/NewServices.css";

const offerings = [
  {
    id: "permanent",
    title: "Permanent Hiring",
    tagline: "Strengthen your core with full-time, code-first talent",
    overview: "Hire dedicated engineers and IT leaders who become long-term members of your team, aligned with your product roadmap and engineering standards.",
    packageIncludes: [
      "Full-time, dedicated developers and technical leads.",
      "Developer-first onboarding with codebase immersion and standards alignment.",
      "Structured career growth and training plans.",
      "Competitive benefits and retention programs.",
      "90-day replacement assurance.",
      "Complimentary 3‑hour technical consulting to scope role requirements and onboarding priorities."
    ],
    costTransparency: [
      "Clear pricing model: monthly salary + fixed service fee; no hidden charges.",
      "Conversion and benefits breakdown provided up front."
    ],
    idealFor: "Core platform roles, engineering managers, and strategic hires where continuity and deep product knowledge matter."
  },
  {
    id: "c2h",
    title: "Contract-to-Hire (C2H)",
    tagline: "Assess performance and culture before committing",
    overview: "Bring specialists on a trial basis to validate technical skills, delivery speed, and team fit before converting to permanent staff.",
    packageIncludes: [
      "Rapid placement of vetted engineers with relevant tech stacks.",
      "Code-focused trial period with measurable deliverables.",
      "Flexible conversion terms based on performance.",
      "Access to freelance specialists if you need interim coverage.",
      "Complimentary 3‑hour consulting session to define success metrics for the trial."
    ],
    costTransparency: [
      "Hourly or fixed-term rates during the trial; clear conversion fee schedule if you hire permanently."
    ],
    idealFor: "Roles where you want to confirm hands-on capability and cultural fit through real work."
  },
  {
    id: "ondemand",
    title: "On-Demand Hiring",
    tagline: "Fast, flexible resourcing for short-term engineering needs",
    overview: "Scale quickly with contract developers, freelancers, or small teams for urgent projects, sprints, or seasonal demand.",
    packageIncludes: [
      "Rapid deployment (24–48 hours) of vetted freelancers and contractors.",
      "Project-based engagements with defined deliverables and milestones.",
      "Flexible durations from one week up to six months.",
      "Specialized skill sets (DevOps, frontend, backend, cloud, QA).",
      "Cost-effective scaling and pay-as-you-go options.",
      "Free 3‑hour consulting to scope the sprint and prioritize backlog items."
    ],
    costTransparency: [
      "Clear hourly/day rates for freelancers; weekly/monthly caps available; no surprise fees."
    ],
    idealFor: "Emergency fixes, short-term feature builds, proof-of-concept work, and seasonal capacity spikes."
  }
];

const whyChooseUs = [
  "Coding-first approach: every placement is evaluated for practical coding ability and system design.",
  "Transparent cost model: upfront rate cards, clear conversion terms, and itemized invoices.",
  "Flexible talent mix: full-time hires, contract-to-hire, and vetted freelancers available.",
  "Risk reduction: trial periods, replacement assurance, and measurable deliverables.",
  "Starter offer: a free 3‑hour consulting session with every engagement to align scope, timelines, and success criteria."
];

const Staffing = () => {
  return (
    <div className="new-services-container">
      <div className="services-hero-banner">
        <div className="services-hero-content">
          <h1 className="services-hero-title">Flexible Hiring Solutions for Every Business Need</h1>
          <p className="services-hero-description">
            From permanent hires to contract-to-hire and on-demand talent—strengthen your team with code-first, vetted engineers.
          </p>
        </div>
      </div>

      <div className="services-content-wrapper">
        <div className="services-section">
          <h2 className="services-section-title">Our Staffing Services</h2>
          <p className="services-section-subtitle">
            Choose the hiring model that best fits your business objectives and timeline.
          </p>

          <Row className="staffing-options-row">
            {offerings.map((offering) => (
              <Col md={4} key={offering.id} className="staffing-option-col">
                <div className="staffing-offering-card">
                  <h3 className="staffing-offering-title">{offering.title}</h3>
                  <p className="staffing-tagline">{offering.tagline}</p>

                  <h4 className="staffing-subhead">Overview</h4>
                  <p className="staffing-overview">{offering.overview}</p>

                  <h4 className="staffing-subhead">Package includes</h4>
                  <ul className="staffing-package-list">
                    {offering.packageIncludes.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>

                  <h4 className="staffing-subhead">Cost transparency</h4>
                  <ul className="staffing-package-list">
                    {offering.costTransparency.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>

                  <h4 className="staffing-subhead">Ideal for</h4>
                  <p className="staffing-ideal-for">{offering.idealFor}</p>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        <div className="services-section included-section">
          <h2 className="services-section-title">Why choose us</h2>
          <ul className="staffing-why-list">
            {whyChooseUs.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Staffing;
